import BaseRouter from 'commons/routers/Base';
import MainView from '../views/Main';
import CompaniesView from '../views/companies/Main';
import ManagersView from '../views/managers/Main';
import SubscriptionView from '../views/Subscription';
import TaxSettingsView from '../../employer/views/settings/TaxSettings';
import Companies from 'newCollections/companies';
import Users from 'newCollections/users.js';
import loader from 'helpers/loader';
import moment from 'moment';

module.exports = BaseRouter.extend({
    routes: {
        'managers': 'managers',
        'companies': 'companies',
        'companies/:sort/:order': 'companies',
        'companies/:sort/:order/:searchTerm': 'companies',
        'subscription': 'subscription',
        'tax': 'tax'
    },

    titles: {
        'companies': 'Companies',
        'companies/:sort/:order': 'Companies',
        'companies/:sort/:order/:searchTerm': 'Companies',
        'managers': 'Managers',
        'subscription': 'Subscription',
        'tax': 'Tax Settings'
    },

    childEl: '#main-area',

    // The initialization of this router is way to complex because the
    // MainView is the container for all the others and it requires async
    // info. TODO Fix MainView
    initialize: function() {
        this.mainView = new MainView({});

        Backbone.history.on('route', function() {
            this.mainView.setActiveLink(Backbone.history.getFragment());
            window.scrollTo(0, 0);
        }.bind(this));

        /*
        if (
            app.user.get('taxInfoValidationStatus') !== 1 &&
            ['employer', 'mpp_admin'].includes(app.user.get('role'))) {

            modal.warning({
                text: 'Please update tax information',
                allowEscapeKey: false,
                allowOutsideClick: false,
                allowEnterKey: false,
                callback: () => app.mainRouter.navigate('tax', {trigger: true})
            });

            $('#tax-info-update-notification').css({display: 'block'});
        }
         */
    },

    companies: function(sortKey, sortOrder, searchTerm) {
        const options = {
            sortKey:    'companyName',
            sortOrder:  'ascending',
            user: app.user,
            // 20200810 why do you need paging on mpp admin at all?
            pagination: false
        };

        if (sortKey) { options.sortKey = sortKey; }
        if (sortOrder) { options.sortOrder = sortOrder; }
        if (searchTerm) { options.searchString = searchTerm; }

        this.view = new CompaniesView({
            el: this.mainView.childEl,
            collection: new Companies(null, options)
        });
    },

    managers: function() {
        /* Since this router is also used by mpp managers, prevent them
         from accessing some routes */
        if (app.user.get('role') !== 'mpp_admin') {
            return;
        }

        const options = {
            user: app.user,
            pagination: false
        };

        let stopLoader = loader.startFullPage(this.mainView.childEl);
        Promise.all([
            new Users(null, options).fetch(),
            new Companies(null, options).fetch({filter: {limit: 9999}})
        ]).then(([managers, companies]) => {
            this.view = new ManagersView({
                el: this.mainView.childEl,
                collection: managers,
                companies: companies
            }).render();
        }).finally(stopLoader);
    },

    subscription: function() {
        if (app.user.get('role') !== 'mpp_admin') {
            return;
        }

        const stopLoader = loader.startFullPage(this.mainView.childEl);
        app.subscription.listInvoices()
            .then(data => {
                let invoices = data.map(i => {
                    let description = '-';
                    let status = i.status.replace(/_/, ' ');
                    status = status[0].toUpperCase() + status.slice(1);
                    /*jscs:disable requireCamelCaseOrUpperCaseIdentifiers*/
                    if (i.line_items && i.line_items.length) {
                        /*jscs:disable requireCamelCaseOrUpperCaseIdentifiers*/
                        description = i.line_items[0].description;
                    }
                    return {
                        id: i._id,
                        date: moment.unix(i.date).format('DD/MM/YYYY'),
                        description: description,
                        amount: (i.total / 100).formatWithoutRounding(),
                        status: status,
                        paymentDate: i.paid_at ?
                            moment.unix(i.paid_at).format('DD/MM/YYYY') : '',
                        voidedDate: i.voided_at ?
                            moment.unix(i.voided_at).format('DD/MM/YYYY') : ''
                    };
                });
                this.view = new SubscriptionView({
                    el: this.mainView.childEl,
                    model: app.subscription,
                    collection: invoices
                }).render();
            }).finally(stopLoader);
    },

    tax: function() {
        if (app.user.get('role') !== 'mpp_admin') {
            return;
        }
        const stopLoader = loader.startFullPage(this.mainView.childEl);
        app.user
            .fetch()
            .then(model => {
                this.view = new TaxSettingsView({
                    el: this.mainView.childEl,
                    model
                });
            })
            .finally(stopLoader);
    }

});



// WEBPACK FOOTER //
// ./app/mpp/routers/Main.js